import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouseNumber = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	width: 29,
	height: 29,
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.6,
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ _jsx("path", { d: "M3.5 11 L12 3.5 L20.5 11" }), /* @__PURE__ */ _jsx("path", { d: "M5.5 9.8 V20.5 H18.5 V9.8" })]
	}), /* @__PURE__ */ _jsx("text", {
		x: 11.5,
		y: 18,
		textAnchor: "middle",
		fontSize: 7.5,
		fontWeight: "bold",
		fill: "currentColor",
		children: "\n      12\n    "
	})]
});
export default SvgHouseNumber;
